<template>
    <ModalCommon :id="id" :config="config" @close="$emit('close')">
        <div v-if="isLoading" class="d-flex justify-content-center">
            <div>
                <LoadingIcon class="d-flex justify-content-center mb-3" />
                <h5 class="text-center">
                    {{ text || $t('common.systemIsProcessing') }}
                </h5>
            </div>
        </div>
    </ModalCommon>
</template>

<script>
import LoadingIcon from '@/components/Loading/main.vue';
import ModalCommon from '@/components/Modal/main.vue';

export default {
    name: 'ModalLoading',
    components: {
        LoadingIcon,
        ModalCommon
    },
    props: {
        id: {
            type: String,
            default: 'ModalLoading'
        },
        config: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ''
        }
    }
};
</script>
